// ── WAS IT COMBINED OR CHOPPED — read off the John Deere pass itself ─────────
//
// Kevin, 2026-10-26: *"If a field was appraised and chopped it's different than appraised and
// combined. ... If it's insured as grain and then gets harvested as grain we can use the
// combine data, but if it's insured as grain and gets chopped for silage, we need to use the
// appraisal."* A chopper's figure is wet SILAGE tonnage. On a grain policy it is not grain
// production, and it must never be reported, or added, as bushels.
//
// ONE rule, read by fieldCoverage (which field figure is production of record) and by
// productionEvidence (which machine passes may stand as a grain monitor figure), so the panel
// and the evidence behind any claim figure cannot disagree about what a pass was.
//
// THE SIGNAL IS JOHN DEERE'S CROP LABEL, CROSS-CHECKED AGAINST THE YIELD UNIT. Measured
// book-wide 2026-10-26 over every corn harvest pass since 2025: label CORN states bu/ac on 907
// of 907 passes that state a unit; label CORN SILAGE states t/ha or ton/ac on 606 of 606 and
// never a dry bushel. Over gridded yield rows the split is total — CORN → bu/ac 1,247 of 1,247,
// CORN SILAGE → t/ha or ton/ac 853 of 853. RED DAWN FARMING LLC's 89 CORN SILAGE passes are all
// t/ha with no dry yield.
//
//   label names SILAGE                       → "chopped"
//   label names the crop without SILAGE      → "combined"
//   a stated unit CONTRADICTING the label    → "unknown"  (bushels on a silage label, a
//                                               tonnage on a grain label) — never resolved by
//                                               picking one
//   no label / NONE / UNSPECIFIED_CROP       → "unknown"

"use strict";

const up = (v) => String(v == null ? "" : v).trim().toUpperCase();

function harvestFormOf(row) {
  const label = up(row && row.crop);
  if (!label || /^(NONE|UNSPECIFIED|UNSPECIFIED_CROP|UNKNOWN)$/.test(label)) return "unknown";
  const unit = String((row && (row.yield_unit != null ? row.yield_unit : row.unit)) || "").trim().toLowerCase();
  const tonUnit = /^t1|^t\/|^ton/.test(unit);
  const buUnit = /^bu/.test(unit);
  if (/SILAGE/.test(label)) return buUnit ? "unknown" : "chopped";
  return tonUnit ? "unknown" : "combined";
}

// A field's form over all its passes: one form if they all agree, "unknown" if they do not.
function combineForms(forms) {
  const s = new Set(forms || []);
  return s.size === 1 ? [...s][0] : "unknown";
}

// ── A CHOPPER'S DRY MATTER, ON THE WET BASIS SILAGE IS MEASURED IN ─────────────
// Kevin: *"We always measure silage yields in wet tons per acre"* and *"I would adjust to 35%
// for silage"* (2026-11-02). John Deere's chopper yield (VRYIELDMAS) is DRY-MATTER short tons
// per acre — api/_jd.js GRID_UNIT_DM, measured against Ops Center's own tiles — and
// jd_field_ftf.mean_value for a CORN SILAGE pass is that grid's mean. Checked 2026-11-03: all
// 333 CY2026 corn-silage grids carry rate_column VRYIELDMAS; HARKINS DAIRY's 16 read 8.19 DM
// t/ac, and JD's own wet weight on those passes (39,608 lb/ac at 59.1% moisture) is 8.1 DM.
//
// ⚠ THIS IS A UNIT CONVERSION, NOT A MOISTURE ADJUSTMENT. DM ÷ 0.35 restates dry matter as
// wet tons at 35% DM (65% moisture) — the same constant and arithmetic as api/_jd.js
// SILAGE_DM_FRACTION / toWetTons, which Yield Analytics and Field Progress print as
// "wet t/ac". The policy's 65% moisture equivalent (7 CFR 457.113 §12(e)(2); Corn LASH
// FCIC-25080 ¶14(4)(b)) only ever adjusts LOW-moisture silage UP, never down, and nothing
// here applies it. tools/check-field-coverage.js holds the two constants equal.
const SILAGE_DM_FRACTION = 0.35;
const silageWetFromDm = (dm) => (dm == null || !Number.isFinite(Number(dm)) ? null : Number(dm) / SILAGE_DM_FRACTION);

module.exports = { harvestFormOf, combineForms, SILAGE_DM_FRACTION, silageWetFromDm };
